import {getEntitySpec, ImageEntity} from './entitySpec';
import React from 'react';

type Ratio = '16:9' | '3:2' | '1:1' | 'original';
type Dimension = {height: 'auto' | number; width: 'auto' | number};

interface ImageSrc {
  path: string;
  description: string | null;
  source: string | null;
  svg: boolean;
}

const generateSources = (
  src: ImageSrc,
  entity: ImageEntity,
  ratio?: Ratio,
  actualWidthFactor?: number,
  width?: number,
  sizesHint?: string
) => {
  const imageSpec = getEntitySpec(entity, ratio);
  const sizes = imageSpec.allowedSizes
    .map((size) => `${src.path}${size.width}x${size.height}.$FILE_TYPE$ ${size.width}w`)
    .join(',');

  // generate fallback src of <img>-tag if sources not supported for file types webp, png and jpeg
  let fallbackSrc = src.path + imageSpec.allowedSizes[1].width + 'x' + imageSpec.allowedSizes[1].height + '.jpeg';

  let sources;
  if (src.svg && imageSpec.fileTypes.includes('svg')) {
    // overwrite fallback img for svg
    fallbackSrc = src.path + 'image.svg';
  } else {
    sources = imageSpec.fileTypes.map((fileType) => {
      if (fileType !== 'svg') {
        const defaultSizesAttribute = actualWidthFactor ? `${100 / actualWidthFactor}vw` : `${width}px`;
        const sizesAttribute = sizesHint || defaultSizesAttribute;
        // generate sources for webp, png and jpeg
        const srcSet = sizes.replace(/\$FILE_TYPE\$/g, `${fileType}`);
        return <source key={fileType} srcSet={srcSet} type={`image/${fileType}`} sizes={sizesAttribute} />;
      }
    });
  }

  return {sources, fallbackSrc};
};

export {generateSources};
export type {Ratio, ImageSrc, Dimension};
